<app-accordion
  [isOpen]="isUpsellAdvantagesOpen"
  (toggled)="togglePolicyBenefits($event)"
  class="upsell__help"
  [class.hide-expand]="!showExpandCollapse"
>
  <ng-container header
    ><h4>
      <ng-content></ng-content></h4
  ></ng-container>
  <ng-container content>
    <p>
      Adding a new protection policy ensures that your replacement appliance has
      continuous cover on things not included in the manufacturer's guarantee:
    </p>

    <ul class="list">
      <li class="list__item list__item--icon-protection">
        Immediate accidental damage cover
        <span class="icon icon-tick icon--xxs"></span>
      </li>
      <li class="list__item list__item--icon-repair">
        Unlimited repairs with no hidden costs
        <span class="icon icon-tick icon--xxs"></span>
      </li>
      <li class="list__item list__item--icon-disposal">
        A new replacement if your model can't be fixed
        <span class="icon icon-tick icon--xxs"></span>
      </li>
    </ul>
  </ng-container>
</app-accordion>
